import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DATE_DD_MM_YYYY } from "common/components/FilterMenu/constants"
import { QUERY_PARAMETERS } from "common/constants"
import moment from "moment"
import { Calendar } from "primereact/calendar"
import { useTranslation } from "react-i18next"

const CalendarioFilter = ({
  fechasFilter,
  setFechasFilter,
  handleCalendarioFilter,
  selectedOptions,
  setSelectedOptions,
  query,
  fetch,
  deleteQuery,
  resetPagination,
}: $TSMigrationFixMe) => {
  const {
    i18n: { language },
  } = useTranslation()

  const handleFechaChange = (e: $TSMigrationFixMe) => {
    if (!e.value) {
      const updatedOptions = selectedOptions?.map(
        (option: $TSMigrationFixMe) => {
          if (option.key === QUERY_PARAMETERS.FechaInicioAsiento) {
            return {
              ...option,
              query: "",
            }
          }
          return option
        }
      )
      setSelectedOptions(updatedOptions)
    }
    setFechasFilter(e.value || null)
    handleCalendarioFilter(e.value || [null, null])
  }

  const resetHandleFecha = async () => {
    setFechasFilter(null)
    resetPagination()
    handleCalendarioFilter([null, null])

    await setSelectedOptions(
      await selectedOptions.filter(
        (opcion: $TSMigrationFixMe) => opcion.key !== `&${deleteQuery[0]}`
      )
    )

    fetch(
      false,
      query
        .replace(new RegExp(`&${deleteQuery[0]}=[^&]*`, "g"), "")
        .replace(new RegExp(`&${deleteQuery[1]}=[^&]*`, "g"), "")
    )
  }

  return (
    <section className='calendar-container tw-h-full tw-relative !tw-mr-0'>
      {fechasFilter && (
        <FontAwesomeIcon
          icon={["fal", "calendar-lines"]}
          className='!tw-absolute tw-text-simple-10 tw-top-2 tw-left-6 tw-h-5 tw-z-10 tw-cursor-pointer tw-pt-0.5'
        />
      )}
      <Calendar
        selectionMode='range'
        className={`${fechasFilter && "calendar-selected"}`}
        locale={language}
        dateFormat='dd/mm/yy'
        value={fechasFilter}
        placeholder={
          fechasFilter
            ? `${moment(fechasFilter?.["0"]).format(
                DATE_DD_MM_YYYY
              )} - ${moment(fechasFilter?.["1"]).format(DATE_DD_MM_YYYY)}`
            : ""
        }
        onChange={handleFechaChange}
        showIcon={!fechasFilter}
      />
      {fechasFilter && (
        <FontAwesomeIcon
          icon={["fal", "xmark"]}
          className='!tw-absolute tw-top-2 tw-right-6 tw-text-simple-10 tw-h-4 tw-w-4 tw-cursor-pointer !tw-pt-1'
          onClick={resetHandleFecha}
        />
      )}
    </section>
  )
}

export default CalendarioFilter
